var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-container"},[_c('img',{class:_vm.css_class,attrs:{"src":_vm.product_image,"alt":_vm.product_alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }